export const hasRoleToken = (role, token) => String(role || '').toLowerCase().includes(token);

export const resolveOnboardingRole = (role) => {
  const roleName = String(role || '').trim().toLowerCase();
  if (roleName === 'owner' || roleName === 'superadmin') return 'owner';
  if (roleName === 'admin') return 'admin';
  if (hasRoleToken(roleName, 'manager')) return 'manager';
  return 'operator';
};
